import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useBrowserPageTitle } from "../../../../components/BrowserPageTitle/BrowserPageTitle";
import {
  PATH_TAXES_SCHEDULE_PAYMENT,
  PATH_TAXES_SCHEDULE_PAYMENT_CONFIRMATION
} from "../../paths";
import { ConfirmationSchedulePayment } from "./ConfirmationSchedulePayment";
import { FormSchedulePayment } from "./FormSchedulePayment";

export const SchedulePaymentToIRS: React.FC = () => {
  useBrowserPageTitle("Taxes - Schedule Payment to IRS", "");

  return (
    <Switch>
      <Route
        path={PATH_TAXES_SCHEDULE_PAYMENT}
        exact
        component={FormSchedulePayment}
      />
      <Route
        path={PATH_TAXES_SCHEDULE_PAYMENT_CONFIRMATION}
        exact
        component={ConfirmationSchedulePayment}
      />
      <Redirect to={PATH_TAXES_SCHEDULE_PAYMENT} />
    </Switch>
  );
};
